import {Button, Box, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";

export interface ContinueLessonViewProps {
    onContinueLessons: () => void;
    onFinishLessons: () => void;
}


const ContinueLessonView: React.FC<ContinueLessonViewProps> = ({ onContinueLessons, onFinishLessons }) => {

    const theme = useTheme();

    document.onkeydown = function (e) {
        if (e.key === "Enter") {
            onContinueLessons();
        } else if (e.key === "Backspace" || e.key === "Escape") {
            onFinishLessons();
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
                maxWidth: 700,
                margin: '0 auto',
                boxSizing: 'border-box',
                padding: 3,
                textAlign: 'center',
            }}
        >
            <Typography variant="h4" sx={{color: theme.palette.text.primary}} gutterBottom>
                Quiz finished!
            </Typography>
            <Typography variant="h6" sx={{color: theme.palette.text.primary}} gutterBottom>
                The new words will be added to your review schedule. <br/> Continue with another lesson?
            </Typography>
            <Box display="flex" justifyContent="space-between" sx={{ mt: 2, gap: 2, width: "100%" }}>
                <Button
                    variant="contained"
                    onClick={onContinueLessons}
                    size={"large"}
                    sx={{
                        mt: 2,
                        borderRadius: 2,
                        width: "40%",
                        backgroundColor: theme.palette.secondary.main,
                        color: theme.palette.secondary.contrastText,
                    }}
                >
                    Continue
                </Button>
                <Button
                    variant="contained"
                    onClick={onFinishLessons}
                    size={"large"}
                    sx={{
                        mt: 2,
                        borderRadius: 2,
                        width: "40%",
                        backgroundColor: theme.palette.info.light,
                        color: theme.palette.info.contrastText,
                    }}
                >
                    Finish
                </Button>
            </Box>
        </Box>
    );

};

export default ContinueLessonView;